import * as React from 'react';
import styled from 'react-emotion';
import { styles } from './styles';
import { ColorTypes } from '@joykit/variables/colors';

interface Props {
  children: React.ReactNode;
  type?: ColorTypes;
  close?: boolean;
}

export const LabelComponent = styled<'div'>('div')<Props>(({ type }) => {
  return styles.label(type);
});

export const Close = styled<'div'>('div')(() => {
  return styles.close;
});

export class Label extends React.Component<Props> {
  static create = (props: Props) => <Label {...props} />;

  render() {
    const { type, children, close } = this.props;
    return (
      <LabelComponent type={type}>
        <div className={styles.contentWrapper}>
          {children}
          {close ? <Close /> : null}
        </div>
      </LabelComponent>
    );
  }
}
